/*
 * The stay chosen on the camp details page, handed to the review page.
 * Kept in sessionStorage so a refresh on the review page still works.
 *
 *   saveStayBooking(stay)  -> CampBookingTab, on "Book Now"
 *   readStayBooking()      -> ReviewBookingCamp
 */
const KEY = 'trvto_stay_booking';

export function saveStayBooking(stay) {
    try {
        sessionStorage.setItem(KEY, JSON.stringify(stay));
    } catch (e) {
        // storage blocked — navigation state still carries it
    }
}

export function readStayBooking() {
    try {
        return JSON.parse(sessionStorage.getItem(KEY) || 'null');
    } catch (e) {
        return null;
    }
}
